function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, PureComponent } from "react";
import { BIGBRAIN_IFRAME_LOCALSTORAGE_EVENTS } from "/constants/bigbrain-event-types";
import Head from "next/head";
import BigBrainScript from "/components/core/head/bigbrain-script";
import { CLUSTERS, SIGNUP_REFERRER, UTM_ADGROUP, UTM_BANNER, UTM_CAMPAIGN, UTM_KEYWORD, UTM_MEDIUM, UTM_SOURCE, LANDING_PAGE } from "/constants/localstorage";
const isProduction = process.env.NODE_ENV === "production";
const PAGE_TYPE = "external_sync";
const BIGBRAIN_QUEUE = "_event_tracker_queue";
class HomepageSyncComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Head, {
                    children: [
                        /*#__PURE__*/ _jsx("script", {
                            dangerouslySetInnerHTML: {
                                __html: this.bigBraingQueueTracker()
                            }
                        }),
                        /*#__PURE__*/ _jsx(BigBrainScript, {
                            isProduction: isProduction,
                            pageType: PAGE_TYPE,
                            preventPageView: true,
                            createVisitor: false
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("script", {
                    dangerouslySetInnerHTML: {
                        __html: this.parentCommunicationScriptGenerator()
                    }
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "parentCommunicationScriptGenerator", ()=>{
            const { parentTargetOrigin } = this.props;
            //  sending data for auth pages:
            return `
        const data = { 
            clusters: JSON.parse(localStorage.getItem('${CLUSTERS}')),
            signupCampaignData: {
                utm_adgroup: JSON.parse(localStorage.getItem('${UTM_ADGROUP}')),
                utm_banner: JSON.parse(localStorage.getItem('${UTM_BANNER}')),
                utm_campaign: JSON.parse(localStorage.getItem('${UTM_CAMPAIGN}')),
                utm_keyword: JSON.parse(localStorage.getItem('${UTM_KEYWORD}')),
                utm_medium: JSON.parse(localStorage.getItem('${UTM_MEDIUM}')),
                utm_source: JSON.parse(localStorage.getItem('${UTM_SOURCE}')),
                signup_referrer: JSON.parse(localStorage.getItem('${SIGNUP_REFERRER}')),
                landing_page: JSON.parse(localStorage.getItem('${LANDING_PAGE}')),
            }
        };
        window.parent.postMessage(JSON.stringify(data), '${parentTargetOrigin}');
    `;
        });
        _define_property(this, "bigBraingQueueTracker", ()=>{
            return `
    let itemsInQueue;
    try {
      itemsInQueue = JSON.parse(localStorage.getItem("${BIGBRAIN_QUEUE}"));
    } catch (e) {}
    document.addEventListener("DOMContentLoaded", () => {
      BigBrain("track", "${BIGBRAIN_IFRAME_LOCALSTORAGE_EVENTS}", { info1: itemsInQueue?.length });
    });`;
        });
    }
}
export { HomepageSyncComponent as default };
